"use client"

import { Hero } from "@/components/landing/Hero"
import { Features } from "@/components/landing/Features"
import { Footer } from "@/components/Footer"
import { BackgroundElements } from "@/components/landing/BackgroundElements"
import { CTASection } from "@/components/landing/CTASection"

export default function Home() {
  return (
    <div className="relative min-h-screen overflow-hidden bg-white">
      <BackgroundElements />
      <Hero />
      <Features />
      <CTASection />
      <Footer />
    </div>
  )
}